import React from 'react';

import Questions from '@/components/Questions';

const Accordion = () => {
  const questionsAnswers = [
    {
      question: '理由-常见问题-用户群体-标题',
      answer: '理由-常见问题-用户群体-答案',
      id: 1,
    },
    {
      question: '理由-常见问题-授课形式班型-标题',
      answer: '理由-常见问题-授课形式班型-答案',
      id: 2,
    },
    {
      question: '理由-常见问题-老师-标题',
      answer: '理由-常见问题-老师-答案',
      id: 3,
    },
    {
      question: '理由-常见问题-价格与购课-标题',
      answer: '理由-常见问题-价格与购课-答案',
      id: 4,
    },
    {
      question: '理由-常见问题-退费保障-标题',
      answer: '理由-常见问题-退费保障-答案',
      id: 5,
    },
  ];

  return (
    <Questions
      questionsAnswers={questionsAnswers}
      useTranslationName="whyWukong"
      className="marginModelTop container mb-20  lg:mb-[100px]  xl:mb-40 "
    />
  );
};

export default Accordion;
